import React from 'react';
import IntegrationInstructionsIcon from "@mui/icons-material/IntegrationInstructions";

const JiraLogo = ({ size = 36 }) => (
  <svg width={size} height={size} viewBox="0 0 256 256" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="jira-a" x1="49.1%" y1="59.3%" x2="24.2%" y2="95.1%">
        <stop stopColor="#0052CC" offset="18%"/>
        <stop stopColor="#2684FF" offset="100%"/>
      </linearGradient>
      <linearGradient id="jira-b" x1="50.4%" y1="40.1%" x2="75.7%" y2="4.5%">
        <stop stopColor="#0052CC" offset="18%"/>
        <stop stopColor="#2684FF" offset="100%"/>
      </linearGradient>
    </defs>
    <path d="M244.658 0H121.707a55.502 55.502 0 0 0 55.502 55.502h22.649v21.895a55.502 55.502 0 0 0 55.502 55.502V11.301A11.301 11.301 0 0 0 244.658 0z" fill="#2684FF"/>
    <path d="M183.822 61.262H60.872a55.502 55.502 0 0 0 55.502 55.502h22.648v21.895a55.502 55.502 0 0 0 55.502 55.502V72.563a11.301 11.301 0 0 0-10.702-11.301z" fill="url(#jira-a)"/>
    <path d="M122.951 122.489H0a55.502 55.502 0 0 0 55.502 55.502h22.649v21.895a55.502 55.502 0 0 0 55.502 55.502V133.79a11.301 11.301 0 0 0-10.702-11.301z" fill="url(#jira-b)"/>
  </svg>
);

const StaysLogo = ({ size = 36 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
    <rect width="100" height="100" rx="16" fill="#00BFA5"/>
    <text x="50" y="62" fontFamily="Arial, sans-serif" fontSize="36" fontWeight="bold" fill="white" textAnchor="middle">S</text>
    <text x="50" y="82" fontFamily="Arial, sans-serif" fontSize="12" fill="white" textAnchor="middle">STAYS</text>
  </svg>
);

const Bitrix24Logo = ({ size = 36 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
    <rect width="100" height="100" rx="16" fill="#2FC7F7"/>
    <text x="50" y="55" fontFamily="Arial, sans-serif" fontSize="20" fontWeight="bold" fill="white" textAnchor="middle">B24</text>
    <text x="50" y="75" fontFamily="Arial, sans-serif" fontSize="10" fill="white" textAnchor="middle">Bitrix24</text>
  </svg>
);

const LOGO_MAP = {
  jira: JiraLogo,
  stays: StaysLogo,
  bitrix24: Bitrix24Logo,
};

const ProviderLogo = ({ slug, logoUrl, size = 36 }) => {
  const [imgError, setImgError] = React.useState(false);

  // Priority 1: URL from database (real logo from CDN)
  if (logoUrl && logoUrl.startsWith('http') && !imgError) {
    return (
      <img
        src={logoUrl}
        alt={slug || 'provider'}
        style={{ width: size, height: size, borderRadius: '8px', objectFit: 'contain', background: '#fff' }}
        onError={() => setImgError(true)}
      />
    );
  }

  // Priority 2: Local SVG fallback by slug
  const LogoComponent = LOGO_MAP[slug?.toLowerCase()];
  if (LogoComponent) return <LogoComponent size={size} />;

  // Priority 3: MUI icon
  return <IntegrationInstructionsIcon sx={{ fontSize: size, color: '#8BC34A' }} />;
};

export default ProviderLogo;
